import { createFileRoute } from "@tanstack/react-router";

import { RoutePage, routeEntry } from "./routeTable";

const entry = routeEntry("/calendars");

export const Route = createFileRoute("/calendars")({
  head: () => ({
    meta: [
      { title: "Site closures — LevelLoad" },
      { name: "description", content: "Site closures — LevelLoad transport planning." },
      { property: "og:title", content: "Site closures — LevelLoad" },
      { property: "og:description", content: "Site closures — LevelLoad transport planning." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <RoutePage entry={entry} />;
}
